import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, Box, IconButton, Typography, Button } from '@mui/material';
import { X } from 'lucide-react';
const FilePreviewModal = ({ open, onClose, fileUrl, fileName }) => {
    const isImage = fileUrl?.startsWith('data:image/') || /\.(jpg|jpeg|png|webp|gif|svg)$/i.test(fileUrl || '');
    const isPDF = fileUrl?.startsWith('data:application/pdf') || /\.pdf$/i.test(fileUrl || '');
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (_jsx(Dialog, { open: open, onClose: onClose, maxWidth: isPDF ? "md" : "sm", fullWidth: isPDF, PaperProps: {
            sx: {
                borderRadius: '16px',
                bgcolor: 'transparent',
                boxShadow: 'none',
                overflow: 'visible',
                m: 2,
                width: isPDF ? '100%' : 'fit-content',
                maxWidth: isPDF ? '900px' : '100%'
            }
        }, children: _jsxs(Box, { sx: { position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }, children: [_jsx(Box, { sx: {
                        position: 'absolute',
                        top: -20,
                        right: 0,
                        display: 'flex',
                        gap: 1.5,
                        zIndex: 1
                    }, children: _jsx(IconButton, { onClick: onClose, sx: { bgcolor: '#FF008E', color: '#fff', '&:hover': { bgcolor: '#E6007A' } }, children: _jsx(X, { size: 20 }) }) }), _jsx(DialogContent, { sx: { p: 0, overflow: 'hidden', borderRadius: '16px', bgcolor: '#fff', minHeight: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }, children: isImage ? (_jsx(Box, { sx: { width: '100%', height: '100%', display: 'flex', justifyContent: 'center', bgcolor: '#000' }, children: _jsx("img", { src: fileUrl, alt: fileName, style: {
                                maxWidth: '100%',
                                maxHeight: '85vh',
                                objectFit: 'contain',
                                display: 'block'
                            } }) })) : isPDF ? (_jsx("iframe", { src: `${fileUrl}#toolbar=0`, title: fileName, width: "100%", height: "85vh", style: { border: 'none', minHeight: '500px' } })) : (_jsxs(Box, { sx: { p: 5, textAlign: 'center' }, children: [_jsx(Typography, { sx: { mb: 2 }, children: "Preview not available for this file type." }), _jsx(Button, { variant: "contained", onClick: () => window.open(fileUrl, '_blank'), sx: { bgcolor: '#FF008E', '&:hover': { bgcolor: '#E6007A' }, textTransform: 'none' }, children: "Open in New Tab" })] })) }), _jsx(Box, { sx: { mt: 1.5, bgcolor: 'rgba(0,0,0,0.6)', px: 2, py: 0.5, borderRadius: '20px' }, children: _jsx(Typography, { sx: { color: '#fff', fontSize: '13px', fontWeight: 500 }, children: fileName }) })] }) }));
};
export default FilePreviewModal;
